export default {
  methods: {
    // 狀態轉換
    convertStatus(status) {
      if (!status) return;
      let word = status.toUpperCase();
      switch (word) {
        case "WAIT":
        case "WAITAPP":
        case "NEW":
          return "群創人員簽核中";
        case "APPROVE":
          return "簽核通過";
        case "CLOSE":
        case "DONE":
          return "審核通過";
        case "DRAFT":
          return "草稿";
        case "REJECT":
          return "拒絕申請";
      }
    },
    // 狀態轉換
    getEffect(effect) {
      return effect === "0" ? "有效" : "無效";
    },
    // 狀態轉換
    getCourseState(status) {
      if (!status) return;
      let word = status.toUpperCase();
      switch (word) {
        case "OPEN":
          return "開放選課";
        case "STOP":
          return "不開課";
        case "FULL":
          return "額滿";
        default:
          return "上課結束";
      }
    },
    // 狀態轉換
    getApproveStatus(status) {
      switch (status) {
        case "0":
          return "待審";
        case "1":
          return "通過";
        case "2":
          return "拒絕";
      }
    },
    // 狀態轉換
    getAttendStatus(status) {
      switch (status) {
        case "0":
          return "未出席";
        case "1":
          return "已出席";
        case "2":
          return "缺席";
      }
    },
    // 狀態轉換
    getIssueCardStatus(status) {
      switch (status) {
        case "0":
          return "待審";
        case "1":
          return "已發卡";
        default:
          return "不發卡";
      }
    },
    // 狀態轉換
    signUpStatus(status, approveStatus) {
      const newDate = this.formatDate(new Date());
      if (status === newDate) {
        return "等待結案";
      } else if (status > newDate && approveStatus === "0") {
        return "未審核";
      } else if (status > newDate && approveStatus === "1") {
        return "通過";
      } else if (status < newDate && approveStatus !== "2") {
        return "已結案";
      } else if (approveStatus === "2") {
        return "拒絕";
      }
    },
    // 日期格式化yyyy/MM/dd
    formatDate(date) {
      let d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("/");
    },
    // file 轉base64
    toBase64(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    // 取得日期(yyyy/mm/dd)
    getDay() {
      let full = new Date();
      return full.toLocaleDateString();
    },
    /**
     * res API 資料回傳結果
     * file_Name 檔案名稱
     * file_Format 檔案型態
     */
    downloadFile(res, file_Name, file_Format) {
      const href = URL.createObjectURL(res.data);
      const link = document.createElement("a");
      link.href = href;
      // file_Name 沒有副檔名 接收file_Format傳入
      if (file_Name.includes(".")) {
        link.setAttribute("download", `${file_Name}`);
      } else {
        link.setAttribute("download", `${file_Name}.${file_Format}`);
      }
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    },
    // 物件value沒有值 key也不傳
    getURLNewParams(obj) {
      let qryString = [];
      let params = "";
      Object.keys(obj).forEach((e) => {
        if (obj[e]) {
          qryString.push(encodeURI(`${e}=${obj[e]}`));
        }
      });
      params = qryString.join("&");
      return params;
    },
    /**
     * 轉換FormData型態
     */
    changeFormData(data) {
      const formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        if (value) {
          if (Array.isArray(value)) {
            value.forEach((item) => {
              formData.append(key, item);
            });
          } else {
            formData.append(key, value);
          }
        }
      });
      return formData;
    },
    /**
     * 節流函數  (在一段時間內，確保函數的執行次數不超過某個次數)
     * @param {調用傳入的函數} fn
     * @param {設定節流的間隔時間(單位為毫秒),如果沒有傳入t,則預設為500毫秒} t
     * @param {設定超過t(時間到期)，是否繼續執行函數,如果沒有傳入timeout2contExecuteFun,則預設為true} timeout2contExecuteFun
     */
    throttle(fn, t, timeout2contExecuteFun = true) {
      let last;
      let timer;
      let interval = t || 500;
      return function () {
        let args = arguments;
        let now = +new Date();
        if (last && now - last < interval) {
          clearTimeout(timer);
          timer = setTimeout(() => {
            last = now;
            if (timeout2contExecuteFun) fn.apply(this, args);
          }, interval);
        } else {
          last = now;
          fn.apply(this, args);
        }
      };
    },
    /**
     * 防抖函數 (當觸發停止後，直到過了某段時間函數才會執行)
     * @param {調用傳入的函數} fn
     * @param {設定防抖的間隔時間(單位為毫秒),如果沒有傳入t,則預設為500毫秒} t
     */
    debounced(fn, t) {
      let delay = t || 500;
      let timer;
      return function () {
        let args = arguments;
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          timer = null;
          fn.apply(this, args);
        }, delay);
      };
    },
  },
};
